import { MoreVert } from '@mui/icons-material';
import FilterListIcon from '@mui/icons-material/FilterList';
import SortIcon from '@mui/icons-material/Sort';
import { Box } from '@mui/material';
import { useTranslation } from 'react-i18next';
import useMiViewScreenCepTargets from './MiViewScreenCepTargets.hook';
import { sortIconStyle, filterListIconStyle, moreVertIconStyle, boxStyle, menuButtonStyle } from './MiViewScreenCepTargets.style';
import { ScreenCepTargetsProps } from './MiViewScreenCepTargets.types';
import MiViewAccountSelector from 'components/MiViewPreview/MiViewAccountSelector/MiViewAccountSelector';
import MiViewMenu from 'components/MiViewPreview/MiViewMenu/MiViewMenu';
import MiViewPlanSelector from 'components/MiViewPreview/MiViewPlanSelector/MiViewPlanSelector';
import MiViewScreenContent from 'components/MiViewPreview/MiViewScreenContent/MiViewScreenContent';
import MiViewScreenHeader from 'components/MiViewPreview/MiViewScreenHeader/MiViewScreenHeader';
import MiViewScreenSelector from 'components/MiViewPreview/MiViewScreenSelector/MiViewScreenSelector';
import MiViewTargetAccordion from 'components/MiViewPreview/MiViewTargetAccordion/MiViewTargetAccordion';
import { CustomerEngagementPlanning } from 'generated/maya.types';
import MiViewPreloader from 'miview-ui/components/MiViewPreloader';

const MiViewScreenCepTargets: React.FC<ScreenCepTargetsProps> = ({
  defaultScreen,
  setNewScreen,
  fullScreen,
  setFullScreen,
  IVADocuments,
  AEDocuments,
  generalLoading,
}) => {
  const { t } = useTranslation();

  const {
    targets,
    tactics,
    screenLoading,
    plans,
    defaultPlan,
    cep,
    selectedAccount,
    setSelectedAccount,
    screenCepTargetsConfig,
    openedAccordion,
  } = useMiViewScreenCepTargets(fullScreen, setFullScreen);

  return (
    <>
      <MiViewScreenHeader>
        <MiViewScreenSelector
          minWidth={ 60 }
          defaultValue={ defaultScreen }
          setNewScreen={ setNewScreen }>
        </MiViewScreenSelector>
        <MiViewPlanSelector minWidth={ 60 } defaultPlan={ defaultPlan } plans={ plans }></MiViewPlanSelector>
        <MiViewAccountSelector
          minWidth={ 60 }
          accounts={ targets }
          selectedAccount={ selectedAccount }
          setSelectedAccount={ setSelectedAccount }>
        </MiViewAccountSelector>
        <SortIcon sx={ sortIconStyle }/>
        <FilterListIcon sx={ filterListIconStyle }/>

        <MiViewMenu menuList={ screenCepTargetsConfig.menuList } buttonStyle={ menuButtonStyle }>
          <MoreVert sx={ moreVertIconStyle }/>
        </MiViewMenu>
      </MiViewScreenHeader>
      <MiViewScreenContent>
        {
          !screenLoading && !generalLoading && targets.length > 0 && !selectedAccount && targets.map((target) => (
            <MiViewTargetAccordion
              key={ target._id }
              target={ target }
              cep={ cep as CustomerEngagementPlanning }
              tactics={ tactics }
              opened={ openedAccordion }
              IVADocuments={ IVADocuments }
              AEDocuments={ AEDocuments }
            />
          ))
        }
        {
          !screenLoading && !generalLoading && targets.length > 0 && selectedAccount && (
            <MiViewTargetAccordion
              key={ selectedAccount._id }
              target={ selectedAccount }
              cep={ cep as CustomerEngagementPlanning }
              tactics={ tactics }
              opened={ openedAccordion }
              IVADocuments={ IVADocuments }
              AEDocuments={ AEDocuments }
            />
          )
        }
        {
          !screenLoading && !generalLoading && !targets.length ? (
            <Box sx={ boxStyle }>
              { t('maya_cep_step_miview_preview_target_screen_no_data') }
            </Box>
          ) : null
        }
        {
          (generalLoading || screenLoading)
            && <MiViewPreloader size={ 50 }></MiViewPreloader>
        }
      </MiViewScreenContent>
    </>
  );
};

export default MiViewScreenCepTargets;
